import createClient from 'openapi-fetch';
import type { paths as administrationPaths } from '../administration/schema';
import { csrfMiddleware } from '../middleware';

type AuthPaths = Pick<
  administrationPaths,
  | '/api/v1/auth/login'
  | '/api/v1/auth/me'
  | '/api/v1/auth/me/password'
  | '/api/v1/auth/setup'
  | '/api/v1/auth/system/status'
>;

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '/';

export const apiClient = createClient<AuthPaths>({
  baseUrl,
  credentials: 'include',
  fetch: (input) => globalThis.fetch(input),
});

apiClient.use(csrfMiddleware);
